import { render } from "./forgeChangeTime.vue?vue&type=template&id=142a85a7"
import script from "./forgeChangeTime.vue?vue&type=script&lang=js"
export * from "./forgeChangeTime.vue?vue&type=script&lang=js"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__